import { handleActions } from "redux-actions";
import { ActionState } from "../../interfaces/action-state";
import { ACTIONS } from "./actions";

const initialState: HomeState = {
	loadSystems: {
		pending: false,
		success: null,
		error: null,
	},
	deleteSystem: {
		pending: false,
		success: null,
		error: null,
	}
};

export default handleActions<HomeState, any>(
	{
		[`${ACTIONS.LOAD_SYSTEMS}_PENDING`]: (state) => {
			return {
				...state,
				loadSystems: {
					pending: true,
					success: null,
					error: null,
				},
			};
		},
		[`${ACTIONS.LOAD_SYSTEMS}_REJECTED`]: (state, action) => {
			return {
				...state,
				loadSystems: {
					pending: false,
					success: null,
					error: action.payload,
				},
			};
		},
		[`${ACTIONS.LOAD_SYSTEMS}_FULFILLED`]: (state, action) => {
			return {
				...state,
				loadSystems: {
					pending: false,
					success: action.payload,
					error: null,
				},
			};
		},
		[`${ACTIONS.DELETE_SYSTEM}_PENDING`]: (state) => {
			return {
				...state,
				deleteSystem: {
					pending: true,
					success: null,
					error: null,
				}
			};
		},
		[`${ACTIONS.DELETE_SYSTEM}_REJECTED`]: (state, action) => {
			return {
				...state,
				deleteSystem: {
					pending: false,
					success: null,
					error: action.payload,
				}
			};
		},
		[`${ACTIONS.DELETE_SYSTEM}_FULFILLED`]: (state, action) => {
			return {
				...state,
				deleteSystem: {
					pending: false,
					success: action.payload,
					error: null,
				}
			};
		},
		[ACTIONS.RESET_DELETED]: (state) => {
			return {
				...state,
				deleteSystem: {
					pending: false,
					success: null,
					error: null,
				}
			};
		},
	},
	initialState
);

export interface HomeState {
	loadSystems: ActionState;
	deleteSystem: ActionState<string | null>;
}
